import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../authentication/auth'
import { AppAside, AppContent, AppSidebar, AppFooter, AppHeader } from '../../components/index'

const RequireAuth = () => {
  const { user, isCheckingSession } = useAuth()
  const location = useLocation()

  // Debug logging
  console.log('RequireAuth - isCheckingSession:', isCheckingSession)
  console.log('RequireAuth - user:', user)
  console.log('RequireAuth - location.pathname:', location.pathname)
  console.log('RequireAuth - location.search:', location.search)

  // Show loading while checking initial session
  if (isCheckingSession) {
    console.log('RequireAuth - Still checking session, showing loader')
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  // If no user after checking, redirect to login
  // FIX: Preserve the full path including query params for redirect after login
  if (user === null || user === undefined) {
    const intendedDestination = location.pathname + location.search
    console.log(
      'RequireAuth - No user, redirecting to login. Intended destination:',
      intendedDestination,
    )

    return <Navigate to="/" replace state={{ from: intendedDestination }} />
  }

  console.log('RequireAuth - User authenticated, rendering protected content')

  // User is authenticated, render protected content
  return (
    <>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <AppContent>
            <Outlet />
          </AppContent>
        </div>
        <AppFooter />
      </div>
      <AppAside />
    </>
  )
}

export default RequireAuth
